import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { FilterRealCompetition } from '../classes/filterRealCompetition';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RealCompetitionService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
    this.entity = 'realcompetition';
  }
  private filterObs$: BehaviorSubject<FilterRealCompetition> = new BehaviorSubject(new FilterRealCompetition());
    getFilterObs(): Observable<FilterRealCompetition> {
        return this.filterObs$.asObservable();
    }
    setFilterObs(filter: FilterRealCompetition) {
          this.filterObs$.next(filter);
    }

}
